import $ from 'jquery';

export default class DynamicInstagram {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.initializedClass = 'instagram-initialized';
    this.photoContainer = $('[data-instagram-photos]', this.el);
    this.numberImagesLoaded = 0;

    const accessToken = $('[data-instagram-token]', this.el).attr('data-instagram-token');
    const isInitialized = this.$el.hasClass(this.initializedClass);

    this._getPhotos(accessToken, isInitialized);
  }

  _getPhotos(accessToken, isInitialized) {
    if (!accessToken.length) {
      this._hasError(false);
      return;
    }

    if (isInitialized) {
      return;
    }

    const url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${accessToken}&count=6&callback=`;

    $.ajax({
      type: 'GET',
      dataType: 'jsonp',
      url,
      success: (response) => {
        if (response.meta.code === 200) {
          for (let i = 0; i < response.data.length; i++) {
            const photo = response.data[i];

            if (photo && photo.images && photo.images.standard_resolution) {
              this.photoContainer.append(`
                <a
                  class="instagram-photo"
                  target="_blank"
                  href="${photo.link}"
                  style="background-image: url('${photo.images.standard_resolution.url}')"
                >
                </a>
              `);
            }

            // Since these images do not use rimg, and they are background images we cannot rely
            // on 'load' or 'rimg:load' events. We can replicate the behaviour by adding the images
            // to a image in the dom and wait for it to load there. This should allow us to
            // know when the images are loaded so we can show the photoContainer.
            $('<img/>').attr('src', photo.images.standard_resolution.url).on('load', (e) => {
              $(e.target).remove();
              this.numberImagesLoaded += 1;
              if (this.numberImagesLoaded >= response.data.length) {
                this.photoContainer.addClass('visible').height('auto');
                $('.loading').hide();
              }
            });
          }

          this.$el.toggleClass(this.initializedClass, true);
        } else {
          this._hasError(response);
        }
      },
      error: response => this._hasError(response),
    });
  }

  _hasError(response) {
    this.$el.toggleClass(this.initializedClass, false);
    this.photoContainer.html();

    if (response) {
      console.log(`Instagram error: ${response.meta.error_message}`);
    }
  }
}
